import { Row, Text } from "@/components";
import { CommuteTime } from "./CommuteTime";

import { locations } from "@/lib/locations";

const LOCATION_CLASS_NAMES = {
  sm: "truncate text-sm text-slate-600",
  xs: "truncate text-xs font-normal text-slate-500",
};

const SEPARATOR_CLASS_NAMES = {
  sm: "shrink-0 text-slate-400",
  xs: "shrink-0 text-xs font-normal text-slate-400",
};

export const LocationAndCommute = ({
  location,
  commuteInfo,
  variant,
}: {
  location: string | null;
  commuteInfo: { distanceMiles: number; durationSeconds: number } | null;
  variant: "sm" | "xs";
}) => {
  /* Render */
  const render = () => {
    if (!location && !commuteInfo) return null;

    return (
      <Row className="min-w-0 items-baseline gap-1">
        {location && (
          <Text className={LOCATION_CLASS_NAMES[variant]}>
            {locations.stripCountrySuffix(location)}
          </Text>
        )}
        {location && commuteInfo && (
          <Text className={SEPARATOR_CLASS_NAMES[variant]}>·</Text>
        )}
        {commuteInfo && (
          <CommuteTime
            durationSeconds={commuteInfo.durationSeconds}
            variant={variant}
          />
        )}
      </Row>
    );
  };

  return render();
};
